/*
 * @Description:
 * @Author: shenkaiyao
 * @Date: 2020-12-23 14:13:15
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2020-12-23 14:14:07
 */
import AudioMonitoring from './audioMonitoring';

export default AudioMonitoring